import * as BiIcons from "react-icons/bi";
import * as BsIcons from "react-icons/bs";
import {forwardRef, type MouseEvent, useContext, useImperativeHandle, useRef} from "react";
import TerminalContainerContext from "./TerminalContainerContext.ts";
import {type TerminalContainerTitleBarRef} from "./TerminalContainerTitleBar.tsx";
import TerminalContainerTab from "./TerminalContainerTab.tsx";


export type TerminalContainerTabContainerRef = HTMLDivElement;

const TerminalContainerTabContainer = forwardRef<TerminalContainerTitleBarRef>(
    (_props, ref) => {
        const divRef = useRef<HTMLDivElement>(null);
        const tabContainerRef = useRef<HTMLUListElement>(null);
        const context = useContext(TerminalContainerContext)!;

        useImperativeHandle(ref, () => divRef.current!);

        function scrollTabs(direction: 'left' | 'right') {
            const container = tabContainerRef.current;
            if (container) {
                const scrollAmount = 150;
                const newScrollPosition =
                    direction === 'left'
                        ? container.scrollLeft - scrollAmount
                        : container.scrollLeft + scrollAmount;
                container.scrollTo({left: newScrollPosition, behavior: 'smooth'});
            }
        }

        function onClickScrollTabs(e: MouseEvent) {
            const target = e.currentTarget as HTMLElement;
            const direction = target.dataset["direction"] as 'left' | 'right';

            if (direction !== 'left' && direction !== 'right')
                throw new Error("Invalid direction");

            scrollTabs(direction);

            context.closeSearchDialog();
        }

        function onClickNewTab() {
            context.newTab();
            context.closeSearchDialog();
        }

        return (
            <div className="d-flex align-items-center px-3" id="terminal-tab-controller" ref={divRef}>
                <button className="btn btn-outline-secondary me-2" data-direction="left" onClick={onClickScrollTabs}>
                    <BiIcons.BiSolidLeftArrow/>
                </button>
                <ul id="terminal-tabs" ref={tabContainerRef} className="nav nav-tabs flex-nowrap">
                    {/*{context.tabs.map((tab) => (<TerminalContainerTab tab={tab}/>))}*/}
                    {context.tabs.map((tab) => <TerminalContainerTab key={tab.reqKey} tab={tab}/>)}
                </ul>
                <button className="btn btn-outline-secondary ms-2" data-direction="right" onClick={onClickScrollTabs}>
                    <BiIcons.BiSolidRightArrow/>
                </button>
                <button
                    type="button"
                    className="button_blue rounded-2 pt-0 pb-1 mb-0  px-2 ms-2"
                    onClick={onClickNewTab}
                    style={{
                        fontSize: "21px",
                        fontWeight: "bold",
                    }}
                    disabled={context.lock}
                ><BsIcons.BsPlusLg/></button>
            </div>
        )
    }
);

export default TerminalContainerTabContainer;